import { motion } from 'motion/react';

const pulseAnimation = {
  opacity: [0.3, 0.6, 0.3],
};

const pulseTransition = {
  duration: 1.5,
  repeat: Infinity,
  ease: 'easeInOut' as const,
};

export function InterstitialSkeleton() {
  return (
    <div className="h-screen w-full flex flex-col items-center bg-black px-6 py-8">
      {/* Content area — top-aligned with padding to match real interstitial positioning */}
      <motion.div
        className="flex flex-col items-center gap-6 w-full max-w-md pt-[10vh]"
        animate={pulseAnimation}
        transition={pulseTransition}
      >
        <div className="w-32 h-32 bg-gray-700 rounded-full" />
        <div className="w-3/4 h-8 bg-gray-700 rounded" />
        <div className="w-1/2 h-6 bg-gray-700 rounded" />
      </motion.div>

      {/* Spacer pushes button to bottom */}
      <div className="flex-1" />

      {/* Bottom button placeholder — matches interstitial button area */}
      <div className="flex w-full shrink-0 justify-center pb-safe-offset-8 pt-4">
        <motion.div
          className="h-[55px] w-[90%] max-w-[28rem] rounded-full bg-gray-700"
          animate={pulseAnimation}
          transition={pulseTransition}
        />
      </div>
    </div>
  );
}
